export default "__VITE_ASSET__Bjer4F0K__"